import MergeTypeRounded from "@mui/icons-material/MergeTypeRounded";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { formatPersonFullName } from "../../../utils/formatters";
import SystemButton from "../../UIToolkit/SystemButton/SystemButton";

/** The two records a merge row names — display name plus id, since duplicates usually share a name. */
export type MergePairLabels = { first: string; firstId: number; second: string; secondId: number };

type LabelledRecord = { id: number; firstName: string; lastName: string };

/** `lastNameFirst` is the department's name-order flag (`useLastNameFirst()`). */
export const mergePairLabels = (first: LabelledRecord, second: LabelledRecord, lastNameFirst: boolean): MergePairLabels => ({
	first: formatPersonFullName(first, lastNameFirst),
	firstId: first.id,
	second: formatPersonFullName(second, lastNameFirst),
	secondId: second.id,
});

type Props = {
	labels: MergePairLabels;
	onClick: () => void;
	dataTestId: string;
};

/** "Review & merge" for one suggested pair of staff records — the action every merge grid's row carries. */
export const MergePairButton: FC<Props> = ({ labels, onClick, dataTestId }) => {
	const { t } = useTranslation();
	return (
		<SystemButton
			buttonVariant="primary"
			size="compact"
			leadingIcon={<MergeTypeRounded />}
			onClick={onClick}
			aria-label={t("duplicates.merge.aria", labels)}
			noFullWidthMobile
			sx={{ width: "100%" }}
			data-testid={dataTestId}
		>
			{t("duplicates.merge.button")}
		</SystemButton>
	);
};
